'use client';

import { useIsAccountSuspended } from '../hooks/useIsAccountSuspended';
import { SuspendedNotificationWarning, type SuspendedNotificationWarningProps } from './SuspendedNotificationWarning';

type SuspendedNotificationProps = SuspendedNotificationWarningProps;

function SuspendedNotification(props: SuspendedNotificationProps) {
  const isAccountSuspended = useIsAccountSuspended();

  if (!isAccountSuspended) {
    return null;
  }

  return <SuspendedNotificationWarning {...props} />;
}

export { SuspendedNotification, type SuspendedNotificationProps };
